import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Button,
  Container,
  Stack,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useNavigate } from "react-router-dom";
import ProfileMenu from "../../../components/ProfileMenu";
import { ASSETS } from "../../../utils/config";
import { colors } from "../../../utils";
import { styled } from "@mui/system";
import { Input } from "../../../components";
import { SearchInput } from "./ExploreBanner";
import { AnimatePresence, motion } from "framer-motion"; // Import Framer Motion
import IyugaDropdown from "../../../components/iyugaDropdown";
import { showCreateWheelPopup } from "../../../redux/reducers/createWheelPopup";
import { useDispatch } from "react-redux";

// Styled Components
const StyledAppBar = styled(AppBar)`
  background-color: ${colors.NeutralBackground};
  box-shadow: 0 10px 7px #00000014;
`;

const Logo = styled("img")`
  height: 40px;
  width: 40px;
  cursor: pointer;
`;

const ActionsContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export default function ExploreAppBar({
  SearchBarComponent,
  ContentTypeDropdown,
  showSearch = false,
}) {
  const nav = useNavigate();
  const dispatch = useDispatch();

  const handleCreateWheel = () => {
    dispatch(showCreateWheelPopup());
  };

  return (
    <StyledAppBar elevation={4} position="sticky">
      <Container maxWidth="100%" sx={{ px: 0 }}>
        <Toolbar
          sx={{
            display: "flex",
            // justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Logo on the left */}
          <div style={{ flex: 1 }}>
            {/* <Logo src={ASSETS.iyugaLogo} alt="Logo" onClick={() => nav("/")} /> */}
            <Logo
              src={ASSETS.iyugaBetaLogo}
              alt="Logo"
              onClick={() => nav("/")}
            />
          </div>

          {/* Show search bar when the banner is out of view */}
          <AnimatePresence mode="wait">
            {showSearch && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.2 }}
              >
                <Stack
                  gap={2}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  flex={1}
                >
                  {SearchBarComponent}
                  <ContentTypeDropdown />
                </Stack>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Actions on the right */}
          <ActionsContainer style={{ flex: 1, justifyContent: "flex-end" }}>
            <Tooltip title="Notifications">
              <IconButton>
                <NotificationsIcon
                  sx={{ color: colors.PrimaryPurple, fontSize: 30 }}
                />
              </IconButton>
            </Tooltip>

            <Button
              sx={{ textTransform: "none" }}
              color="primary"
              variant="outlined"
              onClick={handleCreateWheel}
              startIcon={
                <img
                  src={ASSETS.segmentEditor.AddWheelV2}
                  height={20}
                  width={20}
                  alt="Add Wheel"
                />
              }
            >
              Create Wheel
            </Button>

            <ProfileMenu />
          </ActionsContainer>
        </Toolbar>
      </Container>
    </StyledAppBar>
  );
}
